// extracted by mini-css-extract-plugin
export default {"loginPage":"LoginPage_loginPage__Xey+m"};